<div class="row gy-2 exercise-therapy-plan-list">
  @for (exercise of exercisesInTherapyPlanList; track exercise.id; let idx = $index; let ct = $count) {
    <div class="col-12">
      <div class="exercise-wrapper row g-0">
        <div class="exc-details col-12 col-md">
          <div
            class="sana-card sana-card-light">

            <div class="exc-name">
              Übung {{ idx + 1 }} von {{ ct }}: {{ exercise.title }}
            </div>

            <div class="badges">
              <sana-tp-exercise-activity-badge
                [activityType]="exercise.activityType"></sana-tp-exercise-activity-badge>

              <div> |</div>

              <sana-tp-joint-badge
                [joints]="exercise.joints"></sana-tp-joint-badge>
            </div>

            <div class="numbers">
              Sätze: {{ exercise.numberOfSets }}
              | Wiederholungen: {{ exercise.numberOfRepetitions }}
              @if (exercise.repetitionUnitType === RepetitionUnitTypeEnum.Second) {
                Sekunden
              }
            </div>

            <div class="mt-auto">
              <sana-shared-training-progress-indicator
                [expectedAmountOfTrainings]="progress.expectedAmountOfTrainingsDuringPlan"
                [completedAmountOfTrainings]="progress.amountOfCompletedTrainingsGroupedByExerciseId[exercise.id!]"></sana-shared-training-progress-indicator>
            </div>


            @if (exercise.variationName) {
              <small
                class="sub-info text-tertiary mt-1"
                style="font-weight: 400">
                {{ exercise.variationName }}
              </small>
            }
          </div>
        </div>

        <div class="video-wrapper col-12 col-md-auto">
          <sana-tp-therapist-video-viewer
            [videoTitle]="exercise.variationName!"
            [videoUrl]="exercise.linkToVideo!"
            [vttPath]="'marker/' + exercise.markerFileName!">
          </sana-tp-therapist-video-viewer>
        </div>
      </div>
    </div>
  }
</div>
